// MiniMapControl.tsx
import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet-minimap";
import "leaflet-minimap/src/Control.MiniMap.css";

export default function MiniMapControl() {
  const map = useMap();

  useEffect(() => {
    const layer = L.tileLayer(
      "https://tiles.stadiamaps.com/tiles/stamen_toner/{z}/{x}/{y}{r}.png",
      {
        attribution: "&copy; OpenStreetMap contributors",
      }
    );
    const ctrl = new (L.Control as any).MiniMap(layer, {
      position: "bottomright",
      toggleDisplay: true,
      width: 150,
      height: 150,
      zoomLevelOffset: -5,
    });
    ctrl.addTo(map);
    return () => {
      map.removeControl(ctrl);
    };
  }, [map]);

  return null;
}
